import LocalizedStrings from 'react-localization';
export const lang = new LocalizedStrings({
  en: {
    success: 'You have successfully uninstalled Search Administrator for Chrome',
    sorry: "We're sorry to see you go.",
    help: 'Please help us improve Search Administrator by providing us your feedback.',
    why: 'Why did you uninstall the Search Administrator extension?',
    why_1: "I don't see the benefit of this extension",
    why_2: "I think it's slowing down my computer",
    why_3: "I don't know how it got installed on my browser",
    other: 'Other',
    thank: 'Thank you!',
    thank_you_for: 'Thank you for taking our survey. Your response is very important to us.',
  },
  pt: {
    success: 'Você desinstalou o Search Administrator for Chrome com sucesso',
    sorry: 'É uma pena ver você ir.',
    help: 'Dê sua opinião e ajude-nos a melhorar o Search Administrator.',
    why: 'Why did you uninstall the Search Administrator extension?',
    why_1: 'Não vejo vangagem nessa extensão',
    why_2: 'Acho que está deixando meu computador mais lento',
    why_3: 'Não sei como foi instalado em meu navegador',
    other: 'Outro',
    thank: 'Obrigado!',
    thank_you_for:
      'Agradecemos por fazer nossa pesquisa. Sua resposta é muito importante para nós.',
  },
});



// WEBPACK FOOTER //
// ./src/lang_bye.js